<template>
    <b-modal id="bv-modal-add-priority" size="lg" title="Adicionar uma nova prioridade" scrollable centered no-stackin>
        <b-container fluid>
            <form id="priority-form">
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label for="priotiry-name">Nome da Prioridade</label>
                            <input type="text" class="form-control" id="priotiry-name" v-model="form.name" placeholder="nome da prioridade" :readonly="form.immutable">
                        </div>
                    </div>

                    <div class="col">
                        <div class="form-group">
                            <label for="priotiry-time">Tempo (H:m)</label>
                            <input 
                                type="text" 
                                class="form-control" 
                                id="priotiry-time" 
                                v-model="form.time"
                                placeholder="Ex: 2530 → 25:30"
                                maxlength="5"
                                @input="formatTimeInput"
                                @blur="validateTimeInput"
                            >
                        </div>
                    </div>

                    <div class="col">
                        <div class="form-group">
                            <label for="priotiry-level">Nível</label>
                            <input type="number" min="0" max="5" v-model="form.level" id="priotiry-level" class="form-control"/>
                        </div>
                    </div>
                    
                </div>

                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label for="priotiry-alert">Porcentagem para alerta</label>
                            <input type="range" min="0" max="100" v-model="inputRange" id="priotiry-alert" class="form-control-range"/>
                            <span>{{ inputRange }}%</span>
                        </div>
                    </div>
                    

                    <div class="col">
                        <div class="form-group">
                            <label for="priotiry-color">Cor</label>
                            <input type="color" class="form-control" v-model="form.color" id="priotiry-color">
                        </div>
                    </div>
                </div>
            </form>
        </b-container>

        <template #modal-footer>
            <div class="d-flex flex-row-reverse justify-content-between" style="width: 100%;">
                <button type="submit" @click.prevent="submitForm" class="btn btn-primary" :disabled="loading">
                    <span v-if="loading">
                        <i class="fas fa-spinner fa-pulse"></i> Aguarde...
                    </span>
                    <span v-else>
                        <i class="fas fa-save"></i> Salvar
                    </span>
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { convertSecondsToTime } from '../../../helpers/utils';

export default {
    name: "PriorityTicketModal",
    data() {
        return {
            loading: false,
            inputRange: 0,
            dataEdit: {},
            form: {
                name: '',
                time: "00:00",
                color: '',
                level: 0,
                percent_alert: 0,
                immutable: false,
            }
        }
    },
    computed: {
        isEditing() {
            return this.dataEdit && this.dataEdit.id
        },
    },
    watch: {
        inputRange(value) {
            this.form.percent_alert = Number(value);
        },
        dataEdit: {
            handler(newData) {
                if (newData && Object.keys(newData).length > 0) {
                    this.loadFormData(newData)
                }
            },
            immediate: true
        }
    },
    methods: {
        convertSecondsToTime,
        formatTimeInput(event) {
            const text = event.target.value;
            if (text.length > 5) return;
            let value = text.replace(/\D/g, '');
            if (text.includes(":")) return this.form.time = text;
            if (value.length >= 4) {
                let hours = value.slice(0, -2);
                let minutes = value.slice(-2);
                
                if (parseInt(hours) > 99) hours = '99';
                if (parseInt(minutes) > 59) minutes = '59';
                
                this.form.time = `${hours}:${minutes}`;
            } else {
                this.form.time = value;
            }
        },
        openModal(data) {
            this.resetForm();
            if (data) {
                this.dataEdit = data;
                this.loadFormData(data);
            }
            this.$bvModal.show('bv-modal-add-priority');
        },
        closeModal(data = null) {
            this.loading = false;
            this.resetForm();
            if (data) this.$emit("updatePriorityTable", data);
            this.$bvModal.hide('bv-modal-add-priority');
        },
        loadFormData(data) {
            this.form.id = data.id;
            this.form.name = data.name;
            this.form.time = this.convertSecondsToTime(data.time, false);
            this.form.color = data.color;
            this.form.level = data.level;
            this.form.percent_alert = data.percent_alert;
            this.form.immutable = data.immutable;
            if (data?.percent_alert) this.inputRange = data.percent_alert;
        },
        resetForm() {
            this.form = {
                name: '',
                time: 0,
                color: '',
                level: 0,
                percent_alert: null,
            }
            this.dataEdit = {};
            this.inputRange = 0;
        },
        validateTimeInput() {
            const timePattern = /^\d{1,2}:\d{2}$/;
            if (this.form.time && !timePattern.test(this.form.time)) {
                Swal.fire({
                    type: "error",
                    text: "Formato de tempo inválido! Use o formato HH:MM (ex: 25:30)"
                });
            } else if (this.form.time) {
                const [hours, minutes] = this.form.time.split(':').map(Number);
                if (hours > 99) {
                    Swal.fire({
                        type: "error",
                        text: "Horas não podem ser maiores que 99!"
                    });
                } else if (minutes > 59) {
                    Swal.fire({
                        type: "error",
                        text: "Minutos não podem ser maiores que 59!"
                    });
                }
            }
        },
        validateForm() {
            if (!this.form.name) {
                Swal.fire({
                    type: "error",
                    text: "Campo 'Nome' é obrigatório!"
                });
                return false;
            }

            if (!this.form.time) {
                Swal.fire({
                    type: "error",
                    text: "Campo 'Tempo' é obrigatório!"
                });
                return false;
            }

            const timePattern = /^\d{1,2}:\d{2}$/;
            if (!timePattern.test(this.form.time)) {
                Swal.fire({
                    type: "error",
                    text: "Formato de tempo inválido! Use o formato HH:MM (ex: 25:30)"
                });
                return false;
            }

            const [hours, minutes] = this.form.time.split(':').map(Number);
            if (hours > 99) {
                Swal.fire({
                    type: "error",
                    text: "Horas não podem ser maiores que 99!"
                });
                return false;
            }
            if (minutes > 59) {
                Swal.fire({
                    type: "error",
                    text: "Minutos não podem ser maiores que 59!"
                });
                return false;
            }

            return true;
        },
        async submitForm() {
            if (!this.validateForm()) return;
            this.loading = true;
            const formData = { ...this.form };
            formData.percent_alert = Number(formData.percent_alert);
            formData.level = Number(formData.level);
            formData.time = `${formData.time}:00`;
            try {
                if (this.form.id) {
                    Swal.fire({
                        title: 'Deseja alterar essa prioridade?',
                        text: `As alterações realizadas nessa prioridade serão aplicadas apenas para os próximos tickets abertos.
                        Tickets anteriormente abertos com essa prioridade permaneceram inalterados.`,
                        showCancelButton: true,
                        confirmButtonText: 'Sim',
                        cancelButtonText: 'Não',
                        type: "question",
                        showCloseButton: true,
                        reverseButtons: true
                    }).then(async ({value}) => {
                        if (!value) return this.loading = false;
                        const { data } = await axios.put("ticket/priority", formData)
                        Swal.fire({
                            type: "success",
                            text: "Prioridade atualizado com sucesso."
                        });
                        this.closeModal(data);
                    });
                } else {
                    const { data } = await axios.post("ticket/priority", formData)
                    Swal.fire({
                        type: "success",
                        text: "Prioridade salvo com sucesso."
                    });
                    
                    this.closeModal(data);
                }
            } catch (error) {
                console.error(error);
                Swal.fire({
                    type: "error",
                    text: "Falha ao salvar prioridade! Valide todos os campos e tente novamente."
                });
                this.loading = false;
            }
        },
    },
}
</script>

<style scoped>
.range-container {
    display: flex;
    align-items: center;
    gap: 10px;
    font-family: sans-serif;
}

input[type="range"] {
    width: 200px;
}
</style>